import React, { Component } from "react";
import { CircularProgress } from "@material-ui/core";

export default class BetterCircularProgress extends Component {
    render() {
        return (
            <div>
                {this.props.loading ? (
                    <div style={{ textAlign: "center" }}>
                        <div style={{ marginTop: "10vh", marginBottom: "10vh" }}>
                            <CircularProgress color="inherit" style={{ color: "#223d48" }} size={50} />
                        </div>
                    </div>
                ) : (
                    this.props.children
                )}
            </div>
        );
    }
}
